import { 
/* Scales */
CategoryScale, LinearScale, 
/* Elements */
BarElement, PointElement, LineElement, ArcElement, 
/* Features */
Title, Tooltip, Legend, Filler, } from 'chart.js';
import { Corsair } from './corsair.js';
import { Datalabels } from './datalabels.js';
import { LegendStatePlugin } from './legendStatePlugin/index.js';
/* This plugins always enabled for every chart */
export const defaultPlugins = [
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    ArcElement,
    Filler,
    Legend,
    Title,
    Tooltip,
    Corsair,
    Datalabels,
];
/* This plugins enabled only when they used in chart options */
export const optionalPlugins = [LegendStatePlugin];
export { ChartLegend } from './legendStatePlugin/ChartLegend.js';
export { useTooltipShadowPlugin } from './useTooltipShadowPlugin.js';
